class Config {
    constructor(data) {
        // public
        this.apiHostPublic = data.API_HOST_PUBLIC;
        this.staticBucket = data.STATIC_BUCKET_NAME;
        this.awsRegion = data.AWS_REGION;

        // internal
        this.adminPanelPort = data.ADMIN_PANEL_PORT || 8083;
        this.apiHost = data.API_HOST;

        // computed
        this.staticDownloadPath = `https://${this.staticBucket}.s3.${this.awsRegion}.amazonaws.com`;
    }

    expose() {
        return {
            API_HOST_PUBLIC: this.apiHostPublic,
            STATIC_BUCKET_NAME: this.staticBucket,
            AWS_REGION: this.awsRegion,
        };
    }
}

module.exports = {
    Config
};
